import { CreateWorkspacePage } from "~/pages/space/workspaces/components/CreateWorkspace/CreateWorkspacePage";

const CreateWorkspaceEntryPage = () => {
  return <CreateWorkspacePage />;
};

export default CreateWorkspaceEntryPage;
